<main [@fadeInOut] role="main" id="main-heading" tabindex="0">
  <div class="container-fluid">
    <div class="col-sm-11 center-block">
        <div class="row">
            <div class="col-sm-12">
                <h1 tabindex="0" aria-label="Labeler Code Requests (LCR)" role="heading" aria-level="1">Labeler Code Requests (LCR)</h1>
                <p role="paragraph" tabindex="0">
                    You can create a new Labeler Code Requests form, find an existing form,
                    or browse through all the forms you have in the system with the helpful
                    grid below.
                </p>
                <p id="demo"></p>
            </div>
        </div>
        <div class="row top-space">
            <div class="col-sm-12" aria-label="grid section">
                <nav ngbNav #ngbNav="ngbNav" [(activeId)]="activeTab" (navChange)="tabChanged($event)" tabindex="0" class="nav-tabs">
                    <ng-container ngbNavItem="LCRFormGrid">
                    <a ngbNavLink>
                        <span [attr.aria-label]="count_LCRForm + ' LCR Forms'">LCR ({{ count_LCRForm }})</span>
                    </a>
                        <ng-template ngbNavContent tabindex="0" aria-label="LCR form grid">
                            <div class="row bottom-padding">
                                <div class="col-sm-12" aria-label="grid content">
                                    <ejs-tooltip #tooltip id="tooltip" (beforeRender)="tooltipValue($event)"
                                        target=".e-tooltipcolumn" [enableHtmlParse]="false">

                                        <ejs-grid id='LCR_Form_Grid' #LCRForm_grid [dataSource]='LCRForm_grid_data'
                                            allowPaging='true' allowSorting='true' [pageSettings]='lcrFormsPageSettings'
                                            height="570" (actionBegin)="begin($event)" [toolbar]='toolbarOptions'
                                            allowScrolling="true" allowFiltering="true"
                                            (dataStateChange)="onLCRFormsDataStateChange($event)"
                                            (actionComplete)="gridActionComplete($event)"
                                            (rowSelected)="lcrFormGridRowSelected($event)"
                                            (rowDeselected)="lcrFormGridRowDeselected($event)"
                                             (toolbarClick)='toolbarClick($event)'
                                            [selectionSettings]="{ type: 'Single', checkboxMode: 'ResetOnRowClick' }"
                                            (rowSelecting)="LCRForm_grid.clearSelection()">
                                          <e-columns>
                                            <e-column field='lcrRevisionId'
                                                      isPrimaryKey="true"
                                                      [visible]="false"
                                                      [allowFiltering]="false"
                                                      [allowSorting]="false"></e-column>
                                            <e-column type="checkbox" width="40" *ngIf="hasDeletePermission">
                                            </e-column>
                                            <e-column [customAttributes]="clipmodecolumn" field='formName'
                                                      headerText='Form Name' clipMode="EllipsisWithTooltip" width='300'>
                                              <ng-template #template let-data>
                                                <a class='pointer' *ngIf="data?.lcrRevisionId"
                                                   (click)='viewLCRForm(data.lcrRevisionId)'
                                                   tabindex="0" role="link" [attr.aria-label]="'View ' + data.formName" (keydown.enter)="viewLCRForm(data.lcrRevisionId)">{{data.formName}}</a>
                                              </ng-template>
                                            </e-column>
                                            <e-column [customAttributes]="clipmodecolumn" field='ndcLabelerCode'
                                                      headerText='Labeler Code' clipMode="EllipsisWithTooltip"
                                                      width='150'></e-column>
                                            <e-column [customAttributes]="clipmodecolumn" field='businessCategory'
                                                      headerText='Business Category' clipMode="EllipsisWithTooltip"
                                                      width='230'></e-column>
                                            <e-column [customAttributes]="clipmodecolumn" field='formVersion' type='string'
                                                      headerText='Form Version'
                                                      clipMode="EllipsisWithTooltip" width='130'></e-column>
                                            <e-column [customAttributes]="clipmodecolumn" field='modifiedBy'
                                                      headerText='Modified By' clipMode="EllipsisWithTooltip" width='190'>
                                            </e-column>
                                            <e-column [customAttributes]="clipmodecolumn" [allowFiltering]="false"
                                                      field='formatedModifiedDate' headerText='Modified On'
                                                      [format]="formatOptions"
                                                      clipMode="EllipsisWithTooltip" width='150'>
                                            </e-column>
                                          </e-columns>
                                        </ejs-grid>
                                    </ejs-tooltip>
                                </div>
                            </div>
                        </ng-template>
                    </ng-container>
                    <ng-container ngbNavItem="deliveries">
                    <a ngbNavLink>
                        <span [attr.aria-label]="count_deliveriesLCRForm + ' LCR Deliveries'">LCR Deliveries ({{ count_deliveriesLCRForm }})</span>
                    </a>
                        <ng-template ngbNavContent tabindex="0" aria-label="Deliveries grid">
                            <div [@fadeInOut] class="row bottom-padding">
                                <div class="col-sm-12" tabindex="0" aria-label="grid content">
                                    <div class="grid-spinner-host" #deliveriesSpinnerHost>
                                    <ejs-tooltip #tooltip id="tooltip" (beforeRender)="tooltipValue($event)"
                                        target=".e-tooltipcolumn" [enableHtmlParse]="false">
                                        <ejs-grid id='deliveriesGrid' #deliveries_grid
                                            [dataSource]='LCRDeliveries_grid_data' allowPaging='true'
                                            allowSorting='true' [pageSettings]='deliveriesPageSettings' height="570"
                                            (dataStateChange)="onDeliveriesDataStateChange($event)"
                                            (actionBegin)=begin($event) [toolbar]='toolbarOptions' allowScrolling="true"
                                            allowFiltering="true" (rowSelected)="lcrFormGridRowSelected($event)"
                                            (rowDeselected)="lcrFormGridRowDeselected($event)"
                                            (toolbarClick)='toolbarClick($event)'
                                                  [selectionSettings]="{ type: 'Single', checkboxMode: 'ResetOnRowClick' }"
                                                  (rowSelecting)="deliveries_grid.clearSelection()">
                                          <e-columns>
                                            <e-column type="checkbox" width="40">
                                            </e-column>
                                            <e-column field='lcrRevisionId'
                                                      isPrimaryKey="true"
                                                      [visible]="false"
                                                      [allowFiltering]="false"
                                                      [allowSorting]="false"></e-column>
                                            <e-column [customAttributes]="clipmodecolumn" field='status'
                                                      headerText='Status' clipMode="EllipsisWithTooltip" width='120'>
                                              <ng-template #template let-data>
                                                <span *ngIf="data">{{data.status}}</span>
                                              </ng-template>
                                            </e-column>

                                            <e-column [customAttributes]="clipmodecolumn" field='formName'
                                                      headerText='Form Name' clipMode="EllipsisWithTooltip" width='300'>
                                              <ng-template #template let-data>
                                                <a class='pointer' *ngIf="data?.lcrRevisionId"
                                                   (click)='viewLCRForm(data.lcrRevisionId)'
                                                   tabindex="0" role="link" [attr.aria-label]="'View ' + data.formName"
                                                   (keydown.enter)="viewLCRForm(data.lcrRevisionId)">{{data.formName}}</a>
                                              </ng-template>
                                            </e-column>

                                            <e-column [customAttributes]="clipmodecolumn" headerText='File Name'
                                                      field='fileName' clipMode="EllipsisWithTooltip" width='300'>
                                              <ng-template #template let-data>
                                                <a class='pointer underline' *ngIf="data?.fileName"
                                                   (click)='downloadFile(data.filePath, data.fileName)'
                                                   tabindex="0" role="link" aria-label="Download File"
                                                   (keydown.enter)="downloadFile(data.filePath, data.fileName)">
                                                  <i class="fas fa-download"
                                                     title="Download the file"></i>&nbsp;{{data.fileName}}
                                                </a>
                                              </ng-template>
                                            </e-column>

                                            <e-column [customAttributes]="clipmodecolumn" field='pragmaticValidationStatus' headerText='Pragmatic Validation' clipMode="EllipsisWithTooltip" width='250'>
                                              <ng-template #template let-data>
                                                <app-pragmatic-grid-column [data]="data" (onDownload)="downloadFile($event.filePath, $event.fileName)"></app-pragmatic-grid-column>
                                              </ng-template>
                                            </e-column>

                                            <e-column [customAttributes]="clipmodecolumn" field='ndcLabelerCode'
                                                      headerText='Labeler Code' clipMode="EllipsisWithTooltip"
                                                      width='150'></e-column>
                                            <e-column [customAttributes]="clipmodecolumn" field='businessCategory'
                                                      headerText='Business Category' clipMode="EllipsisWithTooltip"
                                                      width='230'></e-column>
                                            <e-column [customAttributes]="clipmodecolumn" field='formVersion' type='string'
                                                      headerText='Form Version' clipMode="EllipsisWithTooltip" width='130'>
                                            </e-column>
                                            <e-column [customAttributes]="clipmodecolumn" field='modifiedBy'
                                                      headerText='Modified By' clipMode="EllipsisWithTooltip" width='190'>
                                            </e-column>
                                            <e-column [customAttributes]="clipmodecolumn" field='modifiedOn'
                                                      [allowFiltering]="false" headerText='Modified On'
                                                      [format]="formatOptions"
                                                      clipMode="EllipsisWithTooltip" width='150'>
                                            </e-column>
                                                                     </e-columns>
                                                                   </ejs-grid>
                                                               </ejs-tooltip>
                                                              </div>
                                                          </div>
                                                      </div>
                                                  </ng-template>
                                              </ng-container>
                                          </nav>
                                          <div [ngbNavOutlet]="ngbNav"></div>
            </div>
        </div>
        <div *ngIf="hasDeletePermission" class="col-sm-12 grid-actions" tabindex="0">
            <app-delete-button class="hide-element" #deleteLCRButton [canDelete]="!!selectedLcrRevisionId"
                [revisionId]="selectedLcrRevisionId" [apiController]="'LCRForms'"
                [isDraft]="selectedLCRRevisionDraftMode">
            </app-delete-button>
        </div>
        <div *ngIf="hasDeletePermission" class="col-sm-12 grid-actions" tabindex="0">
            <app-delete-button class="hide-element" #deleteLCRDeliveryButton [canDelete]="!!selectedLcrRevisionId"
                [revisionId]="selectedLcrRevisionId" [apiController]="'LCRForms'" [isDelivery]="true">
            </app-delete-button>
        </div>
    </div>
</div>

<div class="sendToFDADiv hide-element" tabindex="0">
    <app-esig-modal #sendToFDAButton [fileName]="'' + selectedLCRRevisionFileName"
        [documentType]="'' + selectedLCRRevisionProductType" [splVersionNumber]="'' + selectedLCRRevisionVersion"
        [formRevisionId]="'' + selectedLcrRevisionId" [orderId]="" (isSuccessfulySubmitted)="onSubmitionToFDA($event)">
    </app-esig-modal>
</div>
</main>
